import { baseApi } from "./baseApi";

export const feedbackApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<unknown, Record<string, unknown>>({
      query: (payload) => ({ url: "/feedback", method: "POST", data: payload }),
    }),
  }),
});

export const { useSubmitFeedbackMutation } = feedbackApi;
